import { includes } from 'lodash';
import ReactIcon from '../Icons';
import { OFFERS_PLATFORMS } from '../../constants';

const baseIcon = {
  color: '#9198A7',
  size: 13,
  marginBottom: '3px',
  marginRight: '-3px',
};
const androidIcon = ReactIcon({ ...baseIcon, type: 'android' });
const appleIcon = ReactIcon({ ...baseIcon, type: 'apple' });
const webIcon = ReactIcon({ ...baseIcon, type: 'web' });

export const getPlatforms = (platforms = []) => {
  if (platforms.length === 0) {
    return [
      {
        key: `web`,
        icon: webIcon,
        text: 'Web',
      },
    ];
  }
  const appleFamily = [OFFERS_PLATFORMS.I_PAD, OFFERS_PLATFORMS.I_PHONE];
  let hasAlreadyAppleIcon = false;
  return platforms
    .filter((platform) => {
      const isApple = appleFamily.indexOf(platform) !== -1;
      if (!isApple) {
        return true;
      }
      if (!hasAlreadyAppleIcon) {
        hasAlreadyAppleIcon = true;
        return true;
      }
      return false;
    })
    .map((platform, index) => {
      const updatedPlatform = {};
      updatedPlatform.key = `${index}-${platform}`;
      switch (platform) {
        case OFFERS_PLATFORMS.ANDROID:
          updatedPlatform.icon = androidIcon;
          return updatedPlatform;
        case OFFERS_PLATFORMS.I_PAD:
          updatedPlatform.icon = appleIcon;
          return updatedPlatform;
        case OFFERS_PLATFORMS.I_PHONE:
          updatedPlatform.icon = appleIcon;
          return updatedPlatform;
        default:
          updatedPlatform.icon = '';
          return updatedPlatform;
      }
    });
};

export const offersLengthByPlatform = (offers = [], key) =>
  offers.filter(({ deviceTypes = [] }) => {
    if (deviceTypes.length === 0) {
      return key === OFFERS_PLATFORMS.WEB;
    }
    return includes(deviceTypes, key);
  });

const isElementInView = (element) => {
  const elementBoundingBox = element.getBoundingClientRect();
  const elementTopY = elementBoundingBox.top;
  const elementBottomY = elementBoundingBox.top + elementBoundingBox.height;
  const elementLeftX = elementBoundingBox.left;
  const elementRightX = elementBoundingBox.left + elementBoundingBox.width;
  return (
    elementTopY >= 0 &&
    elementLeftX >= 0 &&
    elementBottomY <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    elementRightX <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const checkImpression = () => {
  const elements = document.querySelectorAll('.js-offer-points');
  const elementIds = [];
  for (let i = 0; i < elements.length; i += 1) {
    if (isElementInView(elements[i])) {
      elementIds.push(elements[i].getAttribute('data-offer-id'));
    }
  }
  return elementIds;
};

export const areOffersVisible = () => {
  const offersTab = document.querySelector('.js-offerwall-offers-tab');
  if (
    offersTab &&
    offersTab.classList.contains('offerwall-filters-tab-selected')
  ) {
    return true;
  }
  return false;
};
